import { checkWebPSupport } from 'supports-webp-sync';

export default class ImageChooser {
  constructor(images) {
    this.images = this.normalize_images(images);
    this.webp_support = checkWebPSupport();
  }

  map_images() {
    const image_thumb_url = this.get_best_thumbnail(this.images);
    const image_full_url = this.get_best_full_image(this.images);
    const featured_thumb_url = this.get_best_featured_thumb(this.images);

    return {
      image_thumb_url: this.prepend_host(image_thumb_url),
      image_full_url: this.prepend_host(image_full_url),
      featured_thumb_url: this.prepend_host(featured_thumb_url),
    };
  }

  normalize_images(images) {
    // Sometimes we are passed an array. If not, put object in array.
    // We expect each object in the images array to have this structure.
    //  {
    //    "original": {
    //      "url": "https://s1.ticketm.net/dam/c/093/c74cfd95-af21-4e64-9f85-47677b951093_105651_RECOMENDATION_16_9.jpg",
    //      "height": 56,
    //      "width": 100
    //    }
    //  }
    //
    // There may also be a "thumb" image too.

    if (!(images instanceof Array)) {
      images = [images];
    }

    // Remove http images on https sites
    if (global.window && window.location.protocol == 'https:') {
      images = images.filter(function (image) {
        return !(
          (image?.thumb?.url?.match(/^http:/i)) ||
          (image?.original?.url?.match(/^http:/i))
        );
      });
    }

    return images;
  }

  prepend_host(url) {
    if (url && !url.match(/^http/)) {
      // prepend a slash if we need it.
      if (url.substring(0, 1) != '/') {
        url = '/' + url;
      }

      url = (process.env.ASSET_HOST || '') + url;
    }

    if (url) {
      // This is for image testing purpose
      // url = url.replace(/stg/, 'prod');
    }

    return url;
  }

  get_best_video_size(images, big) {
    // First find an image that is roughly 16:9 with the right dimensions.
    for (var i = 0; i < images.length; i++) {
      var image = images[i];

      if (image.original) {
        var image_ratio = this.image_ratio(image.original);
        if (
          image_ratio &&
          image_ratio > 1.2 &&
          image_ratio < 2.5 &&
          (!big || (image.original?.width && image.original.width > 300))
        ) {
          return image;
        }
      }
    }

    // Return the first image.
    if (images[0] && images[0].original) {
      return images[0];
    }
  }

  get_best_squarish(images) {
    // First find an image that is roughly square with the right dimensions.
    for (var i = 0; i < images.length; i++) {
      var image = images[i];

      if (image.original) {
        var image_ratio = this.image_ratio(image.original);
        if (image_ratio && image_ratio > 0.9 && image_ratio < 1.7) {
          return image;
        }
      }
    }

    // Return the first image.
    if (images[0] && images[0].original) {
      return images[0];
    }
  }

  get_best_featured_thumb(images) {
    var image = this.get_best_video_size(images);
    if (image) {
      return (
        (this.webp_support && image.featured_webp && image.featured_webp.url) ||
        (image.featured && image.featured.url) ||
        (image.list_thumb && image.list_thumb.url) ||
        image.original.url
      );
    }
  }

  get_best_thumbnail(images) {
    var image = this.get_best_squarish(images);
    if (image) {
      return (
        (this.webp_support && image.list_thumb_webp && image.list_thumb_webp.url) ||
        (image.list_thumb && image.list_thumb.url) ||
        this.get_best_featured_thumb(images)
      );
    }
  }

  get_best_full_image(images) {
    var image = this.get_best_video_size(images, true);

    if (image) {
      return (
        (this.webp_support && image.hero_webp && image.hero_webp.url) ||
        (image.hero && image.hero.url) ||
        image.original.url
      );
    }
  }

  image_ratio(image) {
    if (image.width && image.height) {
      return image.width / image.height;
    }
  }
}
